<template>
  <div class="d-flex flex-column" style="height: 100%;padding: 30px">
    <h3 v-if="showTitle" class="mb-4 mt-0">
      Zoek product
    </h3>
  
    <div class="input-wrapper" ref="input-wrapper">
      <FormInput class="input"
        v-model="search"

        :focus="true"
        :ske="ske"
        placeholder="Zoek product..."
        @click="showing = true"
      />

      <template v-if="showing">
        <div v-if="loading || forceLoading" class="products-dropdown">
          <ProductListItem v-for="item in placeholder" :key="item.id"
            :minimize="true"
            :show-img="true"
            :ske="true"
          
            v-bind="item"
          />
        </div>
        <div v-else-if="productsWithImages.length" class="products-dropdown disable-ske">
          <ProductListItem v-for="item in productsWithImages" :key="item.id"
            :minimize="true"
            :show-img="true"
          
            v-bind="item"
            @click.native="select(item)"
          />        
        </div>
        <div v-else-if="loaded" class="products-dropdown d-flex justify-content-center align-items-center">
          Geen producten gevonden
        </div>
      </template>
    </div>

    <div v-if="selected.length" class="list-wrapper flex-grow-1">
      <transition-group
        class="flex-grow-1 disable-ske pt-4 disable-ske"
        tag="ul"
        
        @enter="enter"
        @leave="leave"
      >
        <NewOrderItem v-for="item in selected" :key="item.sku"
          v-bind="item"

          :qty.sync="item.qty"
          :price.sync="item.price"
          :error.sync="item.error"
          :removeInputs="removeInputs"
          :removePrice="removePrice"

          @close="remove(item)"
        />
      </transition-group>
    </div>
    <div v-else class="flex-grow-1 d-flex justify-content-center align-items-center">
      <EmptyStatePlaceholder key="empty-staet"
        title="No products selected"
        description="U kunt producten zoeken op 'naam' of 'sku' in het veld hierboven"

        :class="{ske}"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
  
        <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
            <path d="M12,.5,10.6,12.61a1,1,0,0,1-1,.89H4.39a1,1,0,0,1-1-.89L2,.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
            <line x1="1" y1="0.5" x2="13" y2="0.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="7" y1="0.5" x2="7" y2="13.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="2.46" y1="4.5" x2="11.54" y2="4.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="2.98" y1="9" x2="11.02" y2="9" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
          </g></g></svg>
      </EmptyStatePlaceholder>
    </div>
  </div>
</template>

<script>

import FormInput from "../../Inputs/FormInput.vue"
import EmptyStatePlaceholder from "../../../layout/EmptyStatePlaceholder.vue"
import ProductListItem from "../ProductListItem.vue"
import NewOrderItem from "./NewOrderItem.vue"

import transitionFunctionConstructor from "src/mixins/transitionFunctionConstructor.js"

const base = {
  name: "ashtashtashta asht asht asht asht ",
  sku: "ashtashta asht",
}

let selected

export default {
  mixins: [transitionFunctionConstructor()],
  props: {
    value: Array,
    showLoading: Boolean,
    showTitle: Boolean,
    ske: Boolean,
    forceLoading: Boolean,
    removeInputs: Boolean,
    removePrice: Boolean,
  },
  components: {
    FormInput,
    EmptyStatePlaceholder,
    NewOrderItem,
    ProductListItem,
  },
  data() {
    return {
      loading: false,
      search: "",
      showing: false,
      loaded: false,

      products: [],
      selected: [],
      productImages: {},

      placeholder: [
        base,
        base,
        base,
        base,
        base,
      ],
    }
  },
  created() {
    this.$parent.childFormInstance = this

    this.selected = this.value.slice()
  },
  methods: {
    checkFormValidation() {
      return this.hasError
    },
    
    remove({ sku }) {
      this.selected.splice(
        this.selected.findIndex(item => item.sku === sku),
        1 
      )
    },
    select(product) {
      if (!this.selected.find(item => item.sku === product.sku)) {
        this.selected.push({
          price: parseFloat(product.recommended_retail_price),
          qty: 1,
          name: product.name,
          sku: product.sku,
          src: product.src,
          error: false,
        })
      }

      this.showing = false
    },
    
    checkPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (this.$refs["input-wrapper"] === node) {
          found = true
          break
        }
      }
      if (!found) this.showing = false
    },
    async loadImages(products) {
      const images = await Promise.all(
        products.map(async ({sku}) => {
          const files = (await this.axios.get(`/api/products/${sku}/files`)).data.results
          return files && files[0] && files[0].url
        }),
      )
      const productImages = {}
      images.forEach((url, index) => {
        productImages[products[index].sku] = url
      })
      this.productImages = productImages
    },
    async searchProducts() {
      if (!this.showing) return;
      this.loading = true
      
      const products = (await this.axios.get(`/api/products`, {
        params: {
          search: this.search
        },
      })).data.results

/*       if (!products.length) {
        products = (await this.axios.get(`/api/products`, {
          params: {
            sku: this.search,
          },
        })).data.results
      }
 */
      this.loadImages(products)

      this.products = products
      this.loading = false
      this.loaded = true
    },
  },
  computed: {
    productsWithImages() {
      const images = this.productImages || {}
      return this.products.map(item => ({...item, src: images[item.sku]}))
    },
    hasError() {
      return this.selected.some(item => item.error)
    },
  },
  watch: {
    productImages(productImages) {
      this.selected = this.selected.map(item => ({
        ...item,
        src: productImages[item.sku],
      }))
    },
    selected(val) {
      this.$emit("input", val.slice())
    },
    
    showing(val) {
      if (val) {
        window.addEventListener("click", this.checkPath, {passive: true})
      } else {
        window.removeEventListener('click', this.checkPath)
        this.loaded = false
      }
    },
    async value(val) {
      if (val.length && !this.selected.length) {
        this.selected = val.map(item => ({
          price: parseFloat(item.recommended_retail_price),
          qty: 1,
          name: item.name,
          sku: item.sku,
          src: item.src,
          error: false,
        })).slice()
        this.loadImages(this.selected)
      }
    },
    search() {
      this.showing = true
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }

      this.timeout = setTimeout(this.searchProducts, 300)
    },
  },
}

</script>

<style scoped>

.input {
  padding-bottom: 0px;
  margin-bottom: 0;
}

.input-wrapper {
  position: relative;
  z-index: 2;
}

.products-dropdown {
  position: absolute;
  width: 100%;
  height: 300px;
  overflow: auto;
  background-color: white;
  box-shadow: 2px 2px 12px rgb(0,0,0, .2);
}

.products-dropdown.d-flex {
  height: 150px;
  font-size: 1.25em;
}

.list-wrapper {
  position: relative;
}

ul {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
}

</style>
